/* eslint-disable no-return-assign */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';
import * as c from '../constant';

function ViewRetirementCertificate({
  approve,
  data,
  getItem,
  updating,
  generateAmount,
  updateCedulaAmount,
}) {
  const setModal = useContext(ModalContext);
  const [cedulaAmount, setCedulaAmount] = useState(0);
  const [updatedCedulaAmount, setUpdatedCedulaAmount] = useState(0); // get updated cedula amount from  updateCedulaAmount() response
  const [iframeKey, setIframeKey] = useState(1);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const permissions = getJson('permissions');
  const transactionType = _.get(data, 'attributes.transaction_type');

  const src = `${process.env.REACT_APP_WS}${c.BPLS_VIEW_RETIREMENT_CERTIFICATE.replace(
    '{id}',
    _.get(data, 'id')
  )}?bearer_token=${token}&email=${_.get(authProfile, 'email')}&output=I`;

  const handleApprove = e => {
    e.preventDefault();

    approve(_.get(data, 'id'), {}, () => {
      setModal({ isOpen: false });
      getItem(_.get(data, 'id'));
    });
  };

  const cedulaFee = _.get(generateAmount, 'res.data')
    ? _.get(generateAmount, 'res.data')
        .filter(item => item.attributes.sub_group === 'CEDULA')
        .map(cedulaInfo => {
          return { cedulaInfo };
        })
    : '';

  const handleUpdateCedulaAmount = e => {
    e.preventDefault();

    const args = {
      amount: +cedulaAmount,
      fee_id: _.get(cedulaFee, '0.cedulaInfo.id'),
    };

    updateCedulaAmount(_.get(data, 'id'), args, response => {
      const updatedCedulaFee = _.get(response, 'res.data')
        ? _.get(response, 'res.data')
            .filter(item => item.attributes.sub_group === 'CEDULA')
            .map(cedulaInfo => {
              return { cedulaInfo };
            })
        : '';
      setCedulaAmount(
        _.get(updatedCedulaFee, '0.cedulaInfo.attributes.amount_human')
      ); // update cedula amount
      setUpdatedCedulaAmount(
        _.get(updatedCedulaFee, '0.cedulaInfo.attributes.amount_human')
      ); // get updated cedula amount to rerender iframe
      getItem(_.get(data, 'id'));
    });
  };

  useEffect(() => {
    setIframeKey(_.random(1, 1000));
    setCedulaAmount(
      cedulaAmount !== 0
        ? cedulaAmount
        : _.get(cedulaFee, '0.cedulaInfo.attributes.amount_human')
    );
    getItem(_.get(data, 'id'));
  }, [updatedCedulaAmount]); // re-render on update cedula amount

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          {transactionType !== 'CHANGE' &&
            transactionType !== 'DELINQUENT' &&
            transactionType !== 'RETIREMENT' &&
            _.get(data, 'attributes.transaction_status') === 'FOR CHECKING' && (
              <>
                <label className="font-weight-bold mb-0 mr-2">
                  Cedula Amount:
                </label>
                <NumberFormat
                  name="amount"
                  id="amount"
                  placeholder="0"
                  className="form-control w-50"
                  onValueChange={values => setCedulaAmount(values.value)}
                  /* eslint-disable */
                  isNumericString={true}
                  thousandSeparator={true}
                  allowNegative={true}
                  allowLeadingZeros={true}
                  displayType="input"
                  prefix=""
                  value={cedulaAmount || ''}
                />
                &nbsp;
                <button
                  disabled={updating || _.isEmpty(cedulaAmount)}
                  type="button"
                  onClick={handleUpdateCedulaAmount}
                  className="btn btn-secondary"
                >
                  <span className="font-weight-bold">Update</span>
                </button>
                &nbsp;
              </>
            )}
          {['FOR CHECKING'].indexOf(
            _.get(data, 'attributes.transaction_status')
          ) > -1 &&
            ['FOR LICENSE ASSESSMENT'].indexOf(
              _.get(data, 'included.bplsApplication.attributes.status')
            ) > -1 &&
            +_.get(data, 'attributes.is_start_assessment') === 1 &&
            _.get(
              data,
              'included.bplsApplication.attributes.soa_generated_at'
            ) === null &&
            Acl(permissions, ['E2E BPLS APPROVE SOA']) && (
              <button
                type="button"
                onClick={handleApprove}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-dark mr-2   "
              >
                <span className="font-weight-bold">Approve</span>
              </button>
            )}
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewRetirementCertificate.defaultProps = {
  updating: false,
};

ViewRetirementCertificate.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  approve: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  generateAmount: PropTypes.instanceOf(Object).isRequired,
  updateCedulaAmount: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
    codeList: _.get(api, `${c.GET_CODE_LIST}.res.fees`) || [],
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewRetirementCertificate);
